export default "__VITE_ASSET__5a369a12__"